import { render, staticRenderFns } from "./LoginForgot.vue?vue&type=template&id=d17fd1f8&scoped=true"
import script from "./LoginForgot.vue?vue&type=script&lang=js"
export * from "./LoginForgot.vue?vue&type=script&lang=js"
import style0 from "./LoginForgot.vue?vue&type=style&index=0&id=d17fd1f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d17fd1f8",
  null
  
)

export default component.exports